module.exports = __webpack_public_path__ + "img/bghe5.7fb48ee8.png";